import React from 'react'
import "./HomePage.css";

function About(props) {
  return (
  <>
  <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
    <div className="gradient2 aboutcontainer" style={{backgroundColor:`${props.colour}`, display:"flex", justifyContent:"center", alignItems:"center"}}>


      {/*For screen sizes below 992px and between 1120px to 1600px*/}
      <div className="container aboutcontainer1Container1">
        <div className="aboutcontainer1">

          <div className="aboutcontainer1Logo" style={{display:"flex", alignItems:"start"}}>
            <img className="aboutcontainer1LogoImg" style={{height:"1.7rem", width:"10rem" }} src={props.logoUrl} alt="logo"></img>
          </div>

          <div className="aboutcontainer1HeadingContainer" style={{color:"#ffffff"}}>
            <h1 className="aboutcontainer1Heading">{props.heading}</h1>
          </div>

          <div className="aboutcontainer1SubHeadingContainer" style={{color:"#ffffff"}}>
            <h3 className="aboutcontainer1SubHeading">{props.subHeading}</h3>
          </div>

        

          <div className="aboutFeaturesContainer" style={{color:"#ffffff", borderRadius:"5px", display:"flex"}}>
            <div className="aboutFeaturesContainer1" style={{color:"#ffffff", borderRadius:"5px", display:"flex", alignItems:"center"}}>
              <div>
                <img className="aboutFeature1img" src={props.firstIcon} alt="aboutFeature" style={{alignSelf:"center", borderRadius:"50%"}}/>
              </div>
              <div>
                <h3 className="aboutFeature1">{props.firstFeature}</h3>
              </div> 
            </div>

            <div className="aboutFeaturesContainer2" style={{color:"#ffffff", borderRadius:"5px", display:"flex", alignItems:"center"}}>
              <div>
                <img className="aboutFeature2img" src={props.secondIcon} alt="aboutFeature" style={{alignSelf:"center", borderRadius:"50%"}}/>
              </div>
              <div>
                <h3 className="aboutFeature2" >{props.secondFeature}</h3>
              </div> 
            </div>
          </div>

          <div className="aboutFeaturesContainer" style={{color:"#ffffff", borderRadius:"5px",  display:"flex"}}>
            <div className="aboutFeaturesContainer1" style={{color:"#ffffff", borderRadius:"5px",  display:"flex", alignItems:"center"}}>
              <div>
                <img className="aboutFeature1img"  src={props.thirdIcon} alt="aboutFeature" style={{alignSelf:"center", borderRadius:"50%"}}/>
              </div>
              <div>
                <h3 className="aboutFeature1">{props.thirdFeature}</h3>
              </div> 
            </div>

          </div>

        </div>
      </div>
  

      
      {/*For screen sizes between 992px to 1119px*/}
      <div className="aboutcontainer1Container2">
        <div className="aboutcontainer1">

          <div className="aboutcontainer1Logo" style={{display:"flex", alignItems:"start"}}>
            <img className="aboutcontainer1LogoImg" src={props.logoUrl} alt="logo"></img>
          </div>

          <div className="aboutcontainer1HeadingContainer" style={{color:"#ffffff"}}>
            <h1 className="aboutcontainer1Heading">{props.heading}</h1>
          </div>

          <div className="aboutcontainer1SubHeadingContainer" style={{color:"#ffffff"}}>
            <h3 className="aboutcontainer1SubHeading">{props.subHeading}</h3>
          </div>

        

          <div className="aboutFeaturesContainer" style={{color:"#ffffff", borderRadius:"5px", display:"flex"}}>
            <div className="aboutFeaturesContainer1" style={{color:"#ffffff", borderRadius:"5px", display:"flex", alignItems:"center"}}>
              <div>
                <img className="aboutFeature1img" src={props.firstIcon} alt="plusstar" style={{alignSelf:"center", borderRadius:"50%"}}/>
              </div>
              <div>
                <h3 className="aboutFeature1">{props.firstFeature}</h3>
              </div> 
            </div>

            <div className="aboutFeaturesContainer2" style={{color:"#ffffff", borderRadius:"5px", display:"flex", alignItems:"center"}}>
              <div>
                <img className="aboutFeature2img" src={props.secondIcon} alt="plusstar" style={{alignSelf:"center", borderRadius:"50%"}}/>
              </div>
              <div>
                <h3 className="aboutFeature2" >{props.secondFeature}</h3>
              </div> 
            </div>
          </div>

          <div className="aboutFeaturesContainer" style={{color:"#ffffff", borderRadius:"5px",  display:"flex"}}>
            <div className="aboutFeaturesContainer1" style={{color:"#ffffff", borderRadius:"5px",  display:"flex", alignItems:"center"}}>
              <div>
                <img className="aboutFeature1img"  src={props.thirdIcon} alt="plusstar" style={{alignSelf:"center", borderRadius:"50%"}}/>
              </div>
              <div>
                <h3 className="aboutFeature1">{props.thirdFeature}</h3>
              </div> 
            </div>
          </div>

        </div>
      </div>

      <div className="container" style={{backgroundColor:"transparent"}}>
        <div className="aboutcontainer2" style={{padding:"0"}}>
          <img src={props.aboutImage} className="aboutcontainer2img" alt="aboutImage"/>  
        </div>
      </div>



    </div>
  </div>
  </>
  )
}

export default About;